module.exports = "/images/vendor/flag-icon-css/flags/4x3/cd.svg?cd346cdc7caa416803025986e843a600";